import axios from 'axios';
import { convertPath, CONV_STORAGE, electronConfig, lockFocus, room, spacesView, Video, volumeManager } from '../../libs/roomnew';
import KinoPermissions from './KinoPermissions';
import WorkspacePermissions from './WorkspacePermissions';
export default class Permission{
    constructor(){
        this.isWorkspace=(IS_WORKSPACE == 1);
        this.kino_id=ROOM_NAME;
        this.role_id=ROLE;
        this.available=AVAILABLE;
        this.workspacePermissions=new WorkspacePermissions();
        this.kinoPermissions=new KinoPermissions();
    }


    getRolePermisions(){
        return new Promise(async (resolve,reject)=>{
            axios.get(convertPath(`/kino/${this.kino_id}/permissions?role=${this.role_id}`),await electronConfig()).then(res=>{
                if(res.data && typeof res.data == 'object'){
                    if(this.isWorkspace){
                        this.workspacePermissions.setPermissions(res.data);
                    }else{
                        this.kinoPermissions.setPermissions(res.data);
                    }
                    resolve(res.data);
                }else{
                    reject();
                }
            }).catch(err=>{
                console.error(err);
                reject(err)
            })
        })
    }

    kino(){
        return this.isWorkspace ? this.workspacePermissions : this.kinoPermissions;
    }

    isMod(){
        return this.kinoPermissions.isMod();
    }
    isVerifiedMember(){
        return this.kino().isVerifiedMember();
    }
    isAvailable(){
        return this.available;
    }
    applyFeaturePermissions(){
        //chat
        //nav button
        if(this.hasChat()){
            room.setLocalParticipantProperty('has_chat', true);
            $("#panelToggle").removeClass('feature-disabled no-events')
        }else{
            room.setLocalParticipantProperty('has_chat', '');
            $("#panelToggle").addClass('feature-disabled')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('title','This feature is disabled in this workspace.')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }

        //wave
        //nav button
        if(this.hasWave()){
            $("#waveButton").removeClass('feature-disabled no-events')
        }else{
            $("#waveButton").addClass('feature-disabled')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('title','This feature is disabled in this workspace.')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }

        //spaces
        spacesView.renderAddSpaceBox();

        //share screen
        if(this.hasShareScreen()){
            $('#startScreenShare').removeClass('feature-disabled no-events')
        }else{
            $('#startScreenShare').addClass('feature-disabled')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('title','This feature is disabled in this workspace.')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }
        //invite
        if(this.hasInvite()){
            $('#share-kino-toggle').removeClass('feature-disabled no-events')
        }else{
            $('#share-kino-toggle').addClass('feature-disabled')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('title','This feature is disabled in this workspace.')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }

        if(!this.hasPrivateSpaces()){
            CONV_STORAGE.conversationBanner.find("#make-conversation-private").prop('disabled',false)
            .addClass('feature-disabled').attr('data-toggle','tooltip')
            .attr('data-placement','bottom')
            .attr('title','This feature is disabled in this workspace.')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }
        //private conversations
    }


    applySettingsOnJoin(){
        console.log("Applying kino settings on join");
        //mute chatter
        if(this.isWorkspace){
            if(this.shouldMuteChatter()){
                volumeManager.muteChatter();
            }
            if(this.workspacePermissions.getKinoRule('lock_chatter')){
                if(!this.shouldMuteChatter() && this.shouldLockChatter()){
                    volumeManager.muteChatter();
                }
                Video.lockMasterVolume.disableMasterVolumeHandler()
            }
            lockFocus.locked=this.workspacePermissions.getKinoRule('lock_spaces')
            console.log("Setting workspace space lock to ",lockFocus.locked)
            if(this.shouldLockSpaces()){
                lockFocus.focusLockedEvent("",false);
            }else{
                lockFocus.setSpacesLock();
            }

        }
    }

    getRole(){
        return this.kino().getRole();
    }

    setSetting(name,value){
        this.workspacePermissions.kino_rules[name]=value;
        console.log("workspace new settings",this.workspacePermissions.kino_rules)
    }
    setRole(role){
        this.kino().setRole(role);
    }
    canJoinKino(){
        return this.kino().canJoinKino();
    }
    shouldRequestToJoin(){
        return this.kino().shouldRequestToJoin();
    }
    shouldMuteChatter(){
        return this.kino().shouldMuteChatter();
    }
    shouldLockChatter(){
        return this.kino().shouldLockChatter();
    }
    shouldLockSpaces(){
        return this.kino().shouldLockSpaces();
    }
    shouldMuteMicrophone(){
        return this.kino().shouldMuteMicrophone();
    }

    leaveFallbackAssigned(){
        return this.kino().leaveFallbackAssigned();
    }

    shouldRequestToJoinPrivateSpace(){
        return this.kino().shouldRequestToJoinPrivateSpace();
    }

    kinoChatterMuteState(){
        return this.workspacePermissions.kinoChatterMuteState();
    }

    kinoChatterLockState(){
        return this.workspacePermissions.kinoChatterLockState();
    }
    kinoSpacesLockState(){
        return this.workspacePermissions.kinoSpacesLockState();
    }
    initialSpace(){
        return this.kino().initialSpace();
    }

    //features
    hasChat(){
        return this.kino().hasChat();
    }
    hasWave(){
        return this.kino().hasWave();
    }
    hasSpacesManager(){
        return this.kino().hasSpacesManager()
    }
    hasStageView(){
        return this.kino().hasStageView()
    }
    hasKinoTimer(){
        return this.kino().hasKinoTimer();
    }
    hasAnnouncer(){
        return this.kino().hasAnnouncer()
    }
    hasSpacesLock(){
        return this.kino().hasSpacesLock()
    }
    hasPrivateSpaces(){
        return this.kino().hasPrivateSpaces();
    }
    hasMuteAll(){
        return this.kino().hasMuteAll()
    }
    hasMuteLock(){
        return this.kino().hasMuteLock()
    }
    hasAddSpaces(){
        return this.kino().hasAddSpaces();
    }
    hasMuteChatter(){
        return this.kino().hasMuteChatter();
    }
    hasChatterLock(){
        return this.kino().hasChatterLock();
    }
    hasShareScreen(){
        return this.kino().hasShareScreen()
    }
    hasShowtheDoor(){
        return this.kino().hasShowTheDoor();
    }
    hasInvite(){
        return this.kino().hasInvite()
    }
    hasChangeVolume(){
        return this.kino().hasChangeVolume();
    }
    hasKinoRecorder(){
        return this.kino().hasKinoRecorder();
    }
    hasLiveStreaming(){
        return this.kino().hasLiveStreaming();
    }
    hasControlsMenu(){
        if(!this.isWorkspace){
            return this.kino().isMod();
        }else{
            if(this.hasSpacesLock()
            || this.hasMuteAll()){
                return true
            }
        }
        return false
    }
    canAcceptUsers(){
        return this.kino().canAcceptUsers();
    }

};
